import { Box, FormControlLabel, FormHelperText, Radio, RadioGroup, TextField } from '@material-ui/core';
import NameField from '../../UrlMonitoring/NameField';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import moment from 'moment';
import PauseTimeSelector from '../../UrlMonitoring/PauseTimeSelector';
import AdapterDateFns from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

interface MaintananceDurationSectionProps {
  pauseType: PauseType;
  handlePauseTypeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  names: Record<string, string>;
  handleNameChange: (val: string) => void;
  dayStates: Record<string, { enabled: boolean }>;
  daysOfWeek: string[];
  handleCheckboxChange: (day: string) => void;
  selectedDayOfMonth: number | string;
  setSelectedDayOfMonth: Dispatch<SetStateAction<number | ''>>;
  startDate: Date | null;
  endDate: Date | null;
  dateChange: (date: Date | null) => void;
  endDateChange: (date: Date | null) => void;
  startTimeError: boolean;
  startExceedTimeError: boolean;
  endTimeError: boolean;
  DailyTimeRange: string;
  WeeklyTimeRange: string;
  MonthlyTimeRange: string;
    setDailyTimeRange: (val: string) => void;
    setWeeklyTimeRange: (val: string) => void;
    setMonthlyTimeRange: (val: string) => void;
  errors: Record<string, string>;
}

type PauseType = 'daily' | 'weekly' | 'monthly' | 'date_range';

const MaintananceDurationSection: React.FC<MaintananceDurationSectionProps> = ({
  pauseType,
  handlePauseTypeChange,
  names,
  handleNameChange,
  dayStates,
  daysOfWeek,
  handleCheckboxChange,
  selectedDayOfMonth,
  setSelectedDayOfMonth,
  startDate,
  endDate,
  dateChange,
  endDateChange,
  startTimeError,
  startExceedTimeError,
  endTimeError,
  DailyTimeRange,
  WeeklyTimeRange,
  MonthlyTimeRange,
  setDailyTimeRange,
  setWeeklyTimeRange,
  setMonthlyTimeRange,
  errors
}) => {
    const useStyles = makeStyles((theme) => ({
        datePicker: {
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0078db',
          },
          '& .MuiInputLabel-outlined.Mui-focused': {
            color: '#0078db',
          },
        },
    }));
    const classes = useStyles();

    return (
        <>
        <div className="cDateTime cDateInput px-5">
            <RadioGroup
            row
            aria-label="Type"
            name="Type"
            value={pauseType}
            onChange={handlePauseTypeChange}
            style={{
                width: '100%',
                justifyContent: 'space-between',
            }}
            >
            <FormControlLabel
                value="daily"
                control={
                <Radio
                    color="primary"
                />
                }
                label="Daily"
                className="custom-form-control-label"
            />
            <FormControlLabel
                value="weekly"
                control={
                <Radio
                    color="primary"
                />
                }
                label="Weekly"
                className="custom-form-control-label"
            />
            <FormControlLabel
                value="monthly"
                control={<Radio color="primary" />}
                label="Monthly"
                className="custom-form-control-label"
            />
            <FormControlLabel
                value="date_range"
                control={
                <Radio
                    color="primary"
                />
                }
                label="Date Range"
                className="custom-form-control-label"
            />
            </RadioGroup>
        </div>
        <div className="inputs-wrapper">
            <NameField
            name={names[pauseType]}
            onNameChange={handleNameChange}
            />
            <div className="cDateTime">
            <div>
                {/* Weekly Case */}
                {pauseType === 'weekly' && (
                <div className="flex flex-wrap gap-4 weeks-container">
                {daysOfWeek.map((day) => {
                    const id = `checkbox-${day}`;

                    return (
                        <div key={day} className="day-item">
                        <input
                            id={id}
                            type="checkbox"
                            checked={dayStates[day]?.enabled ?? false}
                            onChange={() => handleCheckboxChange(day)}
                        />
                        <label
                            htmlFor={id}
                            className="w-24 font-medium cursor-pointer"
                            style={{ cursor: 'pointer' }}
                        >
                            {day}
                        </label>
                        </div>
                    );
                    })}
                </div>
                )}
                {/* Monthly Case */}
                {pauseType === 'monthly' && (
                <div className="flex monthly-container">
                    <FormControl fullWidth>
                        <InputLabel id="day-select-label" style={{ fontSize: '13px' }}>Select Day</InputLabel>
                        <Select
                            labelId="day-select-label"
                            id="day-select"
                            value={selectedDayOfMonth === '' ? '' : Number(selectedDayOfMonth)}
                            onChange={(e) =>
                            setSelectedDayOfMonth(e.target.value === '' ? '' : Number(e.target.value))
                            }
                            label="Select Day"
                            style={{ fontSize: '14px' }}
                            inputProps={{ style: { fontSize: 14 } }}
                        >
                            <MenuItem value="">Select Day</MenuItem>
                            {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                            <MenuItem key={day} value={day}>
                                {day}
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </div>
                )}
                {pauseType === 'date_range' && (
                <div className="daterange-container">
                    <MuiPickersUtilsProvider utils={AdapterDateFns}>
                    <DateTimePicker
                        TextFieldComponent={(props) => (
                        <TextField {...props} variant="outlined" inputProps={{ style: { fontSize: 14, padding: '18px 14px' } }} InputLabelProps={{ style: { fontSize: 13 } }} />
                        )}
                        label="Start Date Time"
                        value={startDate}
                        format="dd/MM/yyyy, hh:mm a"
                        onChange={dateChange}
                        minDate={moment(new Date())
                        .add(120, 'seconds')
                        .format('YYYY-MM-DD')}
                        helperText={
                        startTimeError
                            ? 'Start time must be 2 minutes more than the present Time'
                            : startExceedTimeError
                            ? 'Start time cannot be more than end time'
                            : ''
                        }
                        className={`w-100 datePicker ${classes.datePicker}`}
                    />
                    </MuiPickersUtilsProvider>
                    <MuiPickersUtilsProvider utils={AdapterDateFns}>
                    <DateTimePicker
                        TextFieldComponent={(props) => (
                        <TextField {...props} variant="outlined" inputProps={{ style: { fontSize: 14, padding: '18px 14px' } }} InputLabelProps={{ style: { fontSize: 13 } }} />
                        )}
                        label="End Date Time"
                        value={endDate}
                        format="dd/MM/yyyy, hh:mm a"
                        onChange={endDateChange}
                        minDate={moment(new Date()).format('YYYY-MM-DD')}
                        helperText={
                        endTimeError ? 'End Time must be greater than Start Time' : ''
                        }
                        className={`w-100 datePicker ${classes.datePicker}`}
                    />
                    </MuiPickersUtilsProvider>
                </div>
                )}
                {pauseType && (
                <PauseTimeSelector
                    pauseType={pauseType}
                    DailyTimeRange={DailyTimeRange}
                    WeeklyTimeRange={WeeklyTimeRange}
                    MonthlyTimeRange={MonthlyTimeRange}
                    setDailyTimeRange={setDailyTimeRange}
                    setWeeklyTimeRange={setWeeklyTimeRange}
                    setMonthlyTimeRange={setMonthlyTimeRange}
                />
                )}
                {pauseType === 'daily' && errors.daily && <FormHelperText error>{errors.daily}</FormHelperText>}
                {pauseType === 'weekly' && errors.weekly && <FormHelperText error>{errors.weekly}</FormHelperText>}
                {pauseType === 'monthly' && errors.monthly && <FormHelperText error>{errors.monthly}</FormHelperText>}
                {pauseType === 'date_range' && errors.date_range && <FormHelperText error>{errors.date_range}</FormHelperText>}
            </div>
            </div>
        </div>
        </>
    );
};

export default MaintananceDurationSection;